/**
 * Created by sagardesai on 19/07/18.
 */

import React, {Component} from 'react';

import {isEmpty, vuepayAlert, formattedPrice} from "../../util/utility";
import {getData, LOGIN, USER_DATA} from "../../util/storage";
import {sendRequestForPaidGroupSession, cancelPaidGroupRequest} from "../../util/firebase/firestore";
import * as actions from "../../actions";
import connect from "react-redux/es/connect/connect";
import {getMoneyBloxWalletBalance} from "../../assets/libs/MoneyBlox";
import {getUserProfile} from "../../util/business_logic";

//image
import loading_white from '../../assets/gif/loading_white.gif';
import assets from "../../util/assets";


class RequestForPaidGroupSessionModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            wallet_balance:"0.00"
        }
        //all the functions used in this component should be listed here for better documentation
    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        //MoneyBlox
        if (nextProps.moneyblox.hasOwnProperty("wallet_balance") &&
            nextProps.moneyblox.hasOwnProperty("user_details") &&
            nextProps.moneyblox.user_details !== null) {
            this.setState({
                wallet_balance:this.props.moneyblox.wallet_balance
            })
        }
        if (this.props.isVisible !== nextProps.isVisible){
            if (nextProps.isVisible){
                getMoneyBloxWalletBalance(this.props, true);
            }
        }
    }


    sendPaidGroupRequestToBroadcaster = () => {

        if ((this.state.wallet_balance * 100) < this.props.broadcaster.broadcast[0].group_session_price) {
            vuepayAlert("error", `Please make sure to have at least ${formattedPrice(this.props.broadcaster.broadcast[0].group_session_price)} to join this session`);
            return
        }

        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                let params = {
                    id: this.props.broadcaster.broadcast[0].id,
                    group: true,
                    onetoone: false,
                    wallet_balance: 1000,
                };
                this.props.requestAvailabilityBroadcast(
                    data.token,
                    data.api_token,
                    params
                );

                this.setState({
                    isFetching: false
                })
                this.props.togglePaidGroupRequestStatus()
                this.props.togglePaidGroupRequestModal()
            } else {
                this.props.history.push({
                    pathname: "/login",
                    state: {basePath: this.props.history.location.pathname},
                });
            }
        });
    }

    cancelPaidGroupRequestSession = () => {

        this.setState({
            isFetching: true
        },() => {
            getData(USER_DATA)
                .then((data) => {
                    if (!isEmpty(data)) {
                        cancelPaidGroupRequest(`${this.props.broadcaster.broadcast[0].id}`,data.user_id, () => {
                            /**
                             * Update parent component about paid group request status
                             */
                            this.setState({
                                isFetching: false
                            })
                            this.props.togglePaidGroupRequestStatus()
                            this.props.togglePaidGroupRequestModal()
                        })
                    }
                })
        })


    }


    render() {
        return (
            <div id="paid-group-request-modal" className="modal fade" role="dialog" aria-labelledby="myModalLabel"
                 aria-hidden="true">
                <div className="vertical-alignment-helper">
                    <div className="modal-dialog vertical-align-center">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                        onClick={this.props.togglePaidGroupRequestModal}>
                                    <img alt={"close-icon"} src={assets.broadcast.cross}/></button>
                            </div>
                            <div className="modal-body">
                                {this.props.broadcaster &&  <div>
                                    <div className="followers-img-wrapper">
                                        <div className="followers-img">
                                            <img src={this.props.broadcaster.profile_pic}  width={"100%"} alt="followers"/>
                                        </div>
                                    </div>
                                    <h5>{this.props.broadcaster.username}</h5>
                                    <p>
                                        {this.props.isPaidGroupRequestSent ? "You have requested a group session"
                                        : "You are requesting a group session"
                                        }
                                    </p>

                                    <div className="border-box">
                                        <p className="">Your credit</p>
                                        {
                                            (this.state.wallet_balance === "0.00" || this.props.moneyblox.user_details === null)
                                                ?
                                                <p className="text-danger" style={{cursor: 'pointer'}} onClick={() => {
                                                    this.props.showMoneyBloxModal()
                                                }}>£0.00</p>
                                                :
                                                <p style={{marginBottom: '1px'}}><strong>£{this.state.wallet_balance}</strong></p>
                                        }
                                    </div>
                                </div>}

                            </div>
                            <div className="modal-footer">
                                {this.props.isPaidGroupRequestSent ?
                                    <button type="button" className="btn btn-outline-primary"
                                            onClick={this.cancelPaidGroupRequestSession}>
                                        {this.state.isFetching ? <img src={loading_white} alt={"Loading"} width={26} height={26}/>:  "Cancel request"} </button>
                                    :
                                    (this.state.wallet_balance === "0.00" || this.props.moneyblox.user_details === null) ?
                                        <button type="button" className="btn btn-outline-primary" disabled>Confirm group request</button>
                                        :
                                    <button type="button" className="btn btn-outline-primary"
                                            onClick={this.sendPaidGroupRequestToBroadcaster}>
                                        {this.state.isFetching ?<img src={loading_white} alt={"Loading"} width={26} height={26}/> : "Confirm group request"}</button>
                                }

                                {
                                    (this.props.moneyblox.user_details === null) ?
                                        <button type="button" className="btn btn-link" style={{cursor:'not-allowed'}} disabled>Add Credit</button>
                                        :
                                        <button type="button" className="btn btn-link" onClick={() => {
                                            this.props.showMoneyBloxModal()
                                        }} >Add Credit</button>
                                }
                                <button type="button" className="btn btn-link" data-dismiss="modal" onClick={this.props.togglePaidGroupRequestModal}>Return to session
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        device: state.device.payload,
        moneyblox: state.moneyblox

    };
}

export default connect(mapStateToProps, actions)(RequestForPaidGroupSessionModal);